//@flow
import React from 'react';
import {Grid} from '@material-ui/core';

import {
  DYNAMIC_HOME_PAGE_SECTIONS,
  HOME_PAGE_SECTION_NAMES,
  NEW_BANNER_GROUP_ID,
} from '../../utils/home-page-sections/constants';

import type {HomePageLayoutSection} from '../../../../entities';
import {useBanners} from '../../utils';
import BannerGroupSection from '../Sections/BannerGroup';
import EmptyBannerGroupSection from '../Sections/BannerGroup/empty-banner-group';
import {useStoreInformationBlocks} from '../../utils/information-block';
import InformationBlock from '../Sections/InformationBlock';
import {useStoreBusinessModel} from '../../../store/utils';

type Props = {
  section: HomePageLayoutSection,
};

export default function HomeLayoutSection(props: Props) {
  const {section} = props;
  const {bannerGroups} = useBanners();
  const {informationBlocks} = useStoreInformationBlocks();

  const businessModel = useStoreBusinessModel();

  const sectionInformation =
    DYNAMIC_HOME_PAGE_SECTIONS[section.pageSectionType];

  if (!sectionInformation) return null;

  if (!sectionInformation.storeBusinessModels.includes(businessModel)) {
    return null;
  }

  const {Component} = sectionInformation;

  if (section.pageSectionType === HOME_PAGE_SECTION_NAMES.STORE_BANNER) {
    const bannerGroup = bannerGroups.find(
      bannerGroup => bannerGroup.id === section.sectionIdentifier
    );

    if (section.sectionIdentifier === NEW_BANNER_GROUP_ID) {
      return (
        <Grid item xs={12}>
          <EmptyBannerGroupSection />
        </Grid>
      );
    }

    if (!bannerGroup) return null;
    return (
      <Grid item xs={12}>
        <BannerGroupSection
          bannerGroup={bannerGroup}
          sectionEnabled={section.enabled}
        />
      </Grid>
    );
  }

  if (
    section.pageSectionType === HOME_PAGE_SECTION_NAMES.STORE_INFORMATION_BLOCK
  ) {
    const informationBlock = informationBlocks?.find(
      block => block.storeInformationBlockId === section.sectionIdentifier
    );

    return (
      <Grid item xs={12}>
        <InformationBlock
          sectionEnabled={section.enabled}
          informationBlock={informationBlock}
        />
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Component sectionEnabled={section.enabled} />
    </Grid>
  );
}
